import * as Constants from '../constants';
import Api from '../lib/Api';

export function getPlaylistAutofillSongs({
  userAuthToken,
  playlistId,
  addedSongs,
  removedSongs,
  numSongs,
  annotationLimit,
}) {
  return Api.apiRequest({
    endpoint: Constants.Api.ApiEndpoints.PODS_GET_PLAYLIST_AUTOFILL_SONGS,
    content: {
      userAuthToken,
      playlistId,
      addedSongs,
      removedSongs,
      numSongs,
      annotationLimit,
    },
  });
}

export function getPlaylistSearchRecommendations({
  userAuthToken,
  playlistId,
  addedSongs,
  removedSongs,
  numSongs,
  start,
  annotationLimit,
}) {
  return Api.apiRequest({
    endpoint: Constants.Api.ApiEndpoints.PODS_GET_PLAYLIST_SEARCH_RECOMMENDATIONS,
    content: {
      userAuthToken,
      playlistId,
      addedSongs,
      removedSongs,
      numSongs,
      start,
      annotationLimit,
    },
  });
}
